import { toastAlert } from "$lib/commons-web2"
import {
  TastyworksRest,
  type Logger,
  type SessionErrorHandler,
} from "@tastyworks/tastyworks-api"
import { _ } from "svelte-i18n"
import session from "./session"

const logger: Logger = {
  warn: console.warn,
  info: console.info,
  error: console.error,
  log: console.log,
}

const sessionErrorHandler: SessionErrorHandler = {
  onInvalidSession: () => {
    // handled by sveltekit error handler
  },
  onOTPRequired: () => {
    // handled by 2fa#onSubmit
  },
  onHttpNetworkError: () =>
    toastAlert("error", "HTTP Network Error", "Network Error"),
}

export const twApiClient = new TastyworksRest.Client(
  import.meta.env.VITE_TW_API_BASE_URL,
  import.meta.env.VITE_TW_VAST_API_BASE_URL,
  logger,
  globalThis.fetch.bind(globalThis),
  sessionErrorHandler,
  session
)

export { default as session } from "./session"
